import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShieldCheck, FileText, X } from 'lucide-react';
function Modal({
  title,
  children,
  onClose
}: {
  title: string;
  children: React.ReactNode;
  onClose: () => void;
}) {
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" onClick={onClose} data-id="element-39">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95,
      y: 20
    }} animate={{
      opacity: 1,
      scale: 1,
      y: 0
    }} exit={{
      opacity: 0,
      scale: 0.95,
      y: 20
    }} transition={{
      duration: 0.25
    }} className="bg-brand-card border border-slate-700 rounded-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-40">
        <div className="sticky top-0 bg-brand-card border-b border-slate-800 px-6 py-4 flex items-center justify-between rounded-t-2xl" data-id="element-41">
          <h2 className="text-xl font-serif font-bold text-white" data-id="element-42">{title}</h2>
          <button onClick={onClose} className="text-slate-400 hover:text-white transition-colors p-1" data-id="element-43">
            <X className="w-5 h-5" data-id="element-44" />
          </button>
        </div>
        <div className="px-6 py-6 text-slate-300 text-sm leading-relaxed space-y-4" data-id="element-45">
          {children}
        </div>
      </motion.div>
    </motion.div>;
}
export function Footer() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  return <>
      <footer className="bg-brand-dark border-t border-slate-800/50 py-8 px-4" data-id="element-46">
        <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-slate-500" data-id="element-47">
          <p data-id="element-48">
            © {new Date().getFullYear()} George Capital Coaching. Todos los
            derechos reservados.
          </p>
          <div className="flex items-center gap-6" data-id="element-49">
            <button onClick={() => setActiveModal('privacy')} className="flex items-center gap-1.5 hover:text-brand-accent transition-colors" data-id="element-50">
              <ShieldCheck className="w-4 h-4" data-id="element-51" />
              Privacidad
            </button>
            <button onClick={() => setActiveModal('terms')} className="flex items-center gap-1.5 hover:text-brand-accent transition-colors" data-id="element-52">
              <FileText className="w-4 h-4" data-id="element-53" />
              Términos
            </button>
          </div>
        </div>
      </footer>

      <AnimatePresence data-id="element-54">
        {activeModal === 'privacy' && <Modal title="Política de Privacidad" onClose={() => setActiveModal(null)} data-id="element-55">
            <p data-id="element-56">
              <strong className="text-white" data-id="element-57">Última actualización:</strong>{' '}
              Abril 2026
            </p>
            <p data-id="element-58">
              En George Capital Coaching, respetamos tu privacidad y nos
              comprometemos a proteger tu información personal.
            </p>

            <h3 className="text-white font-semibold mt-4" data-id="element-59">
              1. Información que recopilamos
            </h3>
            <p data-id="element-60">
              Recopilamos únicamente la información necesaria para procesar tu
              compra y entregarte el producto digital: nombre, correo
              electrónico y datos de pago procesados de forma segura por nuestro
              proveedor de pagos.
            </p>

            <h3 className="text-white font-semibold mt-4" data-id="element-61">
              2. Uso de la información
            </h3>
            <p data-id="element-62">Tu información se utiliza exclusivamente para:</p>
            <ul className="list-disc list-inside space-y-1 ml-2" data-id="element-63">
              <li data-id="element-64">Procesar y entregar tu compra</li>
              <li data-id="element-65">
                Enviarte actualizaciones relacionadas con el producto adquirido
              </li>
              <li data-id="element-66">Brindarte soporte si lo necesitas</li>
            </ul>

            <h3 className="text-white font-semibold mt-4" data-id="element-67">
              3. Protección de datos
            </h3>
            <p data-id="element-68">
              Utilizamos encriptación SSL y procesadores de pago certificados
              para proteger tu información financiera. No almacenamos datos de
              tarjetas de crédito en nuestros servidores.
            </p>

            <h3 className="text-white font-semibold mt-4" data-id="element-69">4. Terceros</h3>
            <p data-id="element-70">
              No vendemos, alquilamos ni compartimos tu información personal con
              terceros con fines comerciales.
            </p>

            <h3 className="text-white font-semibold mt-4" data-id="element-71">5. Contacto</h3>
            <p data-id="element-72">
              Para cualquier consulta sobre privacidad, puedes escribirnos a
              nuestro correo de soporte.
            </p>
          </Modal>}

        {activeModal === 'terms' && <Modal title="Términos y Condiciones" onClose={() => setActiveModal(null)} data-id="element-73">
            <p data-id="element-74">
              <strong className="text-white" data-id="element-75">Última actualización:</strong>{' '}
              Abril 2026
            </p>
            <p data-id="element-76">
              Al adquirir el Método de George Capital Coaching, aceptas los
              siguientes términos:
            </p>

            <h3 className="text-white font-semibold mt-4" data-id="element-77">
              1. Producto digital
            </h3>
            <p data-id="element-78">
              Este es un producto digital de acceso inmediato. Una vez
              completada la compra, recibirás acceso de por vida al material
              adquirido.
            </p>

            <h3 className="text-white font-semibold mt-4" data-id="element-79">2. Uso personal</h3>
            <p data-id="element-80">
              El contenido es para uso personal y educativo. Queda prohibida su
              reproducción, distribución o reventa sin autorización expresa.
            </p>

            <h3 className="text-white font-semibold mt-4" data-id="element-81">3. Resultados</h3>
            <p data-id="element-82">
              Los resultados descritos son ejemplos basados en la aplicación del
              método. Los resultados individuales pueden variar según la
              situación financiera y el nivel de compromiso de cada persona.
            </p>

            <h3 className="text-white font-semibold mt-4" data-id="element-83">
              4. Propiedad intelectual
            </h3>
            <p data-id="element-84">
              Todo el contenido, metodologías y materiales son propiedad
              intelectual de George Capital Coaching y están protegidos por las
              leyes de derechos de autor.
            </p>

            <h3 className="text-white font-semibold mt-4" data-id="element-85">5. Modificaciones</h3>
            <p data-id="element-86">
              Nos reservamos el derecho de modificar estos términos en cualquier
              momento. Las modificaciones serán efectivas desde su publicación.
            </p>

            <h3 className="text-white font-semibold mt-4" data-id="element-87">6. Contacto</h3>
            <p data-id="element-88">
              Para cualquier consulta sobre estos términos, puedes comunicarte
              con nuestro equipo de soporte.
            </p>
          </Modal>}
      </AnimatePresence>
    </>;
}